import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_telephoneStrip = _resolveComponent("telephoneStrip");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_config_provider, {
    namespace: "ue"
  }, {
    default: _withCtx(() => [_createVNode(_component_telephoneStrip)]),
    _: 1
  })]);
}